<template>
  <b-list-group-item>
    <b-row>
      <b-col cols="1">
        <a :href="'#'+$route.path">
          <b-icon icon="x-circle" variant="danger" font-scale="2.5" v-b-popover.hover.right="'Delete Address'" @click="confirmAddressRemove()"></b-icon>
        </a>
      </b-col>
      <b-col cols="6">
        <b-form-input v-model="updAdd.address" @change="updateAddress()"></b-form-input>
      </b-col>
      <b-col cols="3">
        <b-form-input v-model="updAdd.address_type" disabled></b-form-input>
      </b-col>
    </b-row>
  </b-list-group-item>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'UpdateAddresses',
  props: ['address'],
  data() {
    return {
      updAdd: {
        address: this.address.address,
        address_type: this.address.address_type.name
      }
    }
  },
  methods: {
    emitSwitchOverlay(bool) {
      this.$emit('emit-switch-overlay', bool);
    },

    emitFetchEntity() {
      this.$emit('emit-fetch-entity');
    },

    async confirmAddressRemove() {
      // if not, get a confirmation before deleting
      var confirmDel = ''
      this.$bvModal.msgBoxConfirm('Please confirm that you want to remove address '+this.address.address+'!', {
        title: 'Please confirm remove',
        centered: true
      })
      // Confirmed - you can delete the category now!
      .then(value => {
        confirmDel = value
        if (confirmDel == true) {
          this.removeAddress();
        }
      })
      // Error processing modal
      .catch(err => {
        console.log('an error has occurred. '+ err)
      })
    },

    removeAddress() {
      this.$emit('remove-address-from-entity', this.address.id);
    },

    async updateAddress() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "address": this.updAdd.address
      }
      // update order with status of 'ready'
      const { data } = await this.$api.patch('addresses/'+this.address.id,
        body,
        config
      );
      if (data.success == true) {
        this.emitFetchEntity();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem updating the address, please try again later.', {
          title: 'Error updating address',
          centered: true
        })
      }
    },

  }
}
</script>
<style></style>
